import { render } from "./checkboxPage.vue?vue&type=template&id=3e86c09f"
import script from "./checkboxPage.vue?vue&type=script&lang=js"
export * from "./checkboxPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__